export const replacer = (key: string, value: any) => {
  if (key === 'parent') {
    return '[Circular]';
  }
  return value;
};
